import React from 'react';
//import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from "react-router-dom";
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col'
//import { version } from '../../package.json';

const OPWBreadcrumb = (props) => {
    var trailObj;
    var breadcrumbItemsArr = [];

    // Was an array of links passed in? Or just free text?
    try {
        trailObj = JSON.parse(props.trail);
    } catch (e) {
        //console.log('Not a JSON object')
    }
    //console.log('trail type: ' + typeof(trailObj));
    if (typeof(trailObj) !== 'undefined') { //An array of links was passed in
        // Expected format is [["label", "/link"], ["label2", ""], ["label3", "/link3"], etc]
        // Empty link value results in no link
        // Final value in array will become 'active'
        var crumbItem = '';
        for (var crumbIndex = 0; crumbIndex < trailObj.length; crumbIndex++) { //For each crumb of the crumb trail array
            //Construct this breadcrumb item
            var label = trailObj[crumbIndex][0];
            var link = trailObj[crumbIndex][1];
            if (link !== '') { //Only add link if there is a link value
                crumbItem = <Breadcrumb.Item key={crumbIndex} linkAs={Link} linkProps={{to: link}} active={crumbIndex === (trailObj.length - 1)}>{label}</Breadcrumb.Item>
                //console.dir(crumbItem);
            } else {
                /*
                console.log('crumbIndex: ' + crumbIndex + ' type: ' + typeof(crumbIndex));
                console.log('trailObj.length - 1: ' + (trailObj.length - 1) + ' type: ' + typeof(trailObj.length - 1));
                console.log('crumbIndex === (trailObj.length - 1): ' + crumbIndex === (trailObj.length - 1));
                */
                crumbItem = <Breadcrumb.Item key={crumbIndex} active={crumbIndex === (trailObj.length - 1)}>{label}</Breadcrumb.Item>;
            }

            //Add the item to the breadcrumb items array
            breadcrumbItemsArr.push(crumbItem);
            //console.dir(breadcrumbItemsArr);
        }

    } else { //Free text was passed in
        //console.log('Crumbtrail is freetext')
        breadcrumbItemsArr.push(<Breadcrumb.Item key="1" active>{props.trail}</Breadcrumb.Item>);
    }
	return (
		<Breadcrumb className="breadcrumb-div">
        {breadcrumbItemsArr}
        <div>
            <DropdownButton title="Reports" variant="secondary" size="sm">
                <LinkContainer to="/report/WeightChart">
                    <Dropdown.Item eventKey="1" href="/report/WeightChart">Weight chart</Dropdown.Item>
                </LinkContainer>
                {/* <LinkContainer to="/report/distributionByWeek">
                    <Dropdown.Item eventKey="2" href="/report/distributionByWeek">Weight distribution</Dropdown.Item>
                </LinkContainer> */}
                <LinkContainer to="/report/weightDistribution">
                    <Dropdown.Item eventKey="2" href="/report/weightDistribution">Weight distribution</Dropdown.Item>
                </LinkContainer>
                <LinkContainer to="/report/sessionData2">
                    <Dropdown.Item eventKey="3" href="/report/sessionData2">Session data</Dropdown.Item>
                </LinkContainer>
                <LinkContainer to="/report/longTermData">
                    <Dropdown.Item eventKey="4" href="/report/longTermData">Data over time</Dropdown.Item>
                </LinkContainer>
                <Dropdown.Divider />
                <LinkContainer to="/manage/session">
                    <Dropdown.Item eventKey="5" href="/manage/session">Manage Sessions</Dropdown.Item>
                </LinkContainer>
            </DropdownButton>
        </div>
        </Breadcrumb>
	)
}

export default OPWBreadcrumb